import styled from 'styled-components'
import { BodySemi } from 'components/common/typography'
import { TransparentButton } from 'components/common/common_styles'
import { sizeMobile } from 'components/globalStyles'

export const Readout = styled(BodySemi)`
  width: 2ch;
  text-align: center;
  margin: 0 10px;
`

export const ButtonContainer = styled(TransparentButton)`
  @media (max-width: ${sizeMobile}) {
    width: fit-content !important;
  }
`

export const ButtonMain = styled.svg`
  fill: ${props => (props.disabled ? 'white' : 'var(--spBlack)')};
  stroke: ${props => (props.disabled ? 'var(--gray3)' : 'white')};
  cursor: pointer;
  pointer-events: ${props => (props.disabled ? 'none' : 'all')};
  max-width: none;

  & circle {
    stroke: ${props => (props.disabled ? 'var(--gray3)' : 'var(--spBlack)')};
  }

  &:hover {
    fill: #213E3C;

    & circle {
      stroke: #213E3C;
    }
  }
`
